// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__XreNI","menu_sub_item":"Menu_menu_sub_item__3ybXf","navsub":"Menu_navsub__7D0UI","menu_sub_item_icon":"Menu_menu_sub_item_icon__DBcY2"};